var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-all"},[_c('page-list',{attrs:{"tableRander":_vm.tableRander,"fromProject":true,"headBtnsString":"no","getList":_vm.getList,"sortable":_vm.sortable}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }